export default {
  setUser({ commit }, payload) {
    commit('setUser', payload)
  },

  setEmpresaPrincipal({ commit }, payload) {
    commit('setEmpresaPrincipal', payload)
  },

  setGrupoPrincipal({ commit }, payload) {
    commit('setGrupoPrincipal', payload)
  },

  setPrefix({ commit }, payload) {
    commit('setPrefix', payload)
  },

  setPapel({ commit }, payload) {
    commit('setPapel', payload)
  }
}
